import slugify from "slugify";
import * as moment from 'moment-timezone';
import { IBrandDetails } from "src/app/core/domain/brand.model";
import pluralize from 'pluralize'
import { NgbCalendar, NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { IMeetingAvailability, METTING_AVAILABILITY } from "src/app/core/domain/meetings.model";
import { ACCOUNT_TYPE, AccountTypeTitleKey } from "src/app/core/domain";
import { accountTypelabelMap } from "src/CONSTS";
import { IProfileDetails } from "src/app/core/domain/profile.model";
import { getTitleFromNavLink, MissingFormKeyToUrlMapping } from "../constants/constants";
import { profileGapBenefit } from "../constants/profile-gap-benefits";
import { IOnboardingDesignHero, IOnboardingDesignLogos } from "src/app/core/domain/settings.model";

export const createSlug = (name) => {
  if (!name || typeof name !== 'string') {
    return '';
  }
  return slugify(name, {
    replacement: '-',  // replace spaces with replacement character, defaults to `-`
    remove: undefined, // remove characters that match regex, defaults to `undefined`
    lower: true,      // convert to lower case, defaults to `false`
    strict: true,     // strip special characters except replacement, defaults to `false`
    locale: 'vi',       // language code of the locale to use
    trim: true         // trim leading and trailing replacement chars, defaults to `true`
  });

  // const slug = name.split(' ').join('-').toLocaleLowerCase();
  // return slug;
}

export function generateTimeSlots(interval: number = 15): string[] {
  let times = [];
  let start = moment({ hour: 0, minute: 0, second: 0, millisecond: 0 });

  for (let i = 0; i < (24 * 60) / interval; i++) {
    times.push(start.format('HH:mm'));
    start.add(interval, 'minutes');
  }

  return times;
}

export function generateTimeSlotsWithAMPM(interval: number = 15): Array<{ label: string, value: string }> {
  let times = generateTimeSlots(interval);

  const mappedData = times.map((e) => {
    return { value: e, label: moment(e, 'HH:mm').format('hh:mm A') }
  })
  return mappedData;
}

/**
 * Input 23:23 or 02:10 in local time, returns uat time
 */
export function convertToUTC(time: string, format: string = 'HH:mm'): string {
  // create a moment object using the given local time
  let localTime = moment(time, format);

  // convert the local time moment to a UTC moment
  let utcTime = localTime.tz('UTC');

  // format the UTC time as a string and return
  return utcTime.format(format);
}

export function convertToLocalTime(time: string, format: string = 'HH:mm'): string {
  // create a moment object using the given UTC time and specifying that the input is in UTC
  let utcTime = moment.utc(time, format);

  // convert UTC time to local time
  let localTime = utcTime.local();

  // format the local time as a string and return
  return localTime.format(format);
}

/**
 * @param times Creates time slots array alsp converts from utc to local time
 */
export function createTimeSlots(times: any = [], localTime = false, singleSlotTime=15): string[] {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timeSlots: string[] = [];
  times.forEach((time: any) => {
    const format = 'HH:mm';
    let startTime = localTime ?moment(time.startTime, format):moment.utc(time.startTime, format);
    let endTime = localTime ?moment(time.endTime, format):moment.utc(time.endTime, format);
    if (time.endTime == '00:00') {
      endTime.add(1, 'day')
    }

    // Note: Handle case where starttime = 00:00 and endtime = 22:30 (after timezone change it becomes 18:30 to 17:00)
    if(startTime.isAfter(endTime)) {
      endTime.add(1, 'day')
    }

    let currentTime = startTime;

    while (currentTime <= endTime) {
      const localTime = currentTime.tz(timeZone).format(format);
      timeSlots.push(localTime);
      currentTime = currentTime.add(singleSlotTime, 'minutes');
    }
  });

  return timeSlots;
}

export const isDisabledDateForMeeting = (date: NgbDate, calenderAvilablity: IMeetingAvailability, calendar: NgbCalendar, disabledDaysIndex: any[]) => {
  // SAN-760 — calenderAvilablity itself can still be undefined while the
  // availability fetch is in flight; only `.dates` was previously guarded.
  if (calenderAvilablity?.dates?.length) {
    const monthPadded = date.month.toString().padStart(2, '0')
    const datePadded = date.day.toString().padStart(2, '0')
    const foundDate = calenderAvilablity.dates.find((e) => e.date === `${date.year}-${monthPadded}-${datePadded}`)
    if (foundDate) {
      if (foundDate.closed) {
        return true
      } else {
        return false
      }
    }
  }

  return (disabledDaysIndex.includes(calendar.getWeekday(new NgbDate(date.year, date.month, date.day))))
    ? true
    : false;
}

export const findNextAvailableDate = (calenderAvilablity: IMeetingAvailability, calendar: NgbCalendar, disabledDaysIndex: any[], startDate=  new Date()) => {
  const today = startDate;
  const totalDays = moment().daysInMonth();
  const month = new Date(today).getMonth() + 1;
  const day = new Date(today).getDate()
  const datesToCheck = []
  for (let i = day; i <= totalDays; i++) {
    datesToCheck.push({
      month: month,
      day: i,
      year: today.getFullYear()
    })
  }

  const availableDateFound = datesToCheck.find((date) => {
    const isDisabled = isDisabledDateForMeeting(date, calenderAvilablity, calendar, disabledDaysIndex)
    return !isDisabled
  })
  console.log('datesToCheck', datesToCheck, availableDateFound)
  return availableDateFound
}


export const createLookingForOptionsFromBrandDetails = (brandDetails: IBrandDetails) => {
  const defaultSelect = brandDetails.features.looking_for_section ? false : true;
  const lookingForOptions = [{
    label: 'Fund Raising',
    value: 'fundraising',
    selected: defaultSelect,
    show: true
  },
  {
    label: 'Hiring',
    value: 'tech_hiring',
    selected: defaultSelect,
    show: brandDetails.features.jobs
  },
  {
    label: 'Market Access',
    value: 'customer_access',
    selected: defaultSelect,
    show: brandDetails.users.corporates
  },
  {
    label: 'Mentorship',
    value: 'mentorship',
    selected: defaultSelect,
    show: brandDetails.users.mentors
  },
  {
    label: 'Business Services',
    value: 'business_services',
    selected: defaultSelect,
    show: brandDetails.users.service_providers
  }];

  return lookingForOptions
}


export const isDateInCurrentWeek = (date) => {
  // Get the current date
  const currentDate = moment();

  // Get the start and end of the current week
  const startOfWeek = currentDate.clone().startOf('week');
  const endOfWeek = currentDate.clone().endOf('week');

  // Check if the provided date is within the current week
  return moment(date).isBetween(startOfWeek, endOfWeek, null, '[]');
};



export const getFavIconUrl = (domain) => {
  return `https://www.google.com/s2/favicons?domain=${domain}&sz=128`
}

export const getYouTubeThumbnail = (url) => {
  let videoId = getIdFromUrl(url);
  return 'https://img.youtube.com/vi/' + videoId + '/maxresdefault.jpg';
}

export const getIdFromUrl = (url) => {
  let videoId;
  if (url.includes('youtu.be')) {
    videoId = url.split('/').pop();
  } else if (url.includes('youtube.com/embed')) {
    videoId = url.split('/').pop();
  } else { // Assuming it's a watch URL
    var urlObj = new URL(url);
    videoId = urlObj.searchParams.get('v');
  }
  return videoId
}

export const getEmbedUrl = (id) => {
  return `https://www.youtube.com/embed/${id}`
}

export function toSingular(plural = '') {
  return pluralize.singular(plural)
}

export function formatEnumStringForUI(inputString) {
  // Split the input string by underscores
  let words = inputString.split('_');

  // Capitalize the first letter of each word
  let formattedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));

  // Join the words back together with spaces
  let formattedString = formattedWords.join(' ');

  return formattedString;
}

/* SAN-780/BRD FR-5.1/FR-5.2: two new merged event-type enum values
   (demo_day_product_launch, tradeshow_exhibition_conference) need a "/"
   separator formatEnumStringForUI()'s generic title-casing can't produce on
   its own -- same reason 'webinar' already gets special-cased to
   "Seminar/Webinar" wherever event type is displayed. Historical events
   under any of the 5 old individual types (product_launch, trade_show,
   exhibition, conference, demo_day) are untouched by the BRD's
   going-forward-only merge and already render fine through the generic
   formatter, so they need no entry here. */
export function formatEventTypeLabel(eventType: string): string {
  const formatted = formatEnumStringForUI(eventType);
  if (formatted === 'Webinar') return 'Seminar/Webinar';
  if (eventType === 'demo_day_product_launch') return 'Demo Day / Product Launch';
  if (eventType === 'tradeshow_exhibition_conference') return 'Tradeshow / Exhibition / Conference';
  return formatted;
}





export const calculateSlots = async ({
  date,
  calendar,
  calenderAvilablity,
  brandDetails,
  timeSlots,
  dateAvailability,
  localtime = false,
  bufferTime = 0,
  calculatingEndTime = false
}) => {
  const dayIndex = calendar.getWeekday(new NgbDate(date.year, date.month, date.day))
  console.log('calenderAvilablity', calenderAvilablity)
  const dayInfo = calenderAvilablity.days?.find((e) => e.dayIndex === dayIndex) || []
  console.log('update date', date, dayIndex, calenderAvilablity.days, { dayInfo })

  const month = ('' + date.month).length === 2 ? date.month : '0' + date.month
  const day = ('' + date.day).length === 2 ? date.day : '0' + date.day

  const dateAvailabilityFromUser = calenderAvilablity?.dates || [];
  const selectedDateFormatted = `${date.year}-${month}-${day}`
  const foundDateAvailabilityFromUser = dateAvailabilityFromUser.find((e) => e.date === selectedDateFormatted)
  if(foundDateAvailabilityFromUser?.times?.length) {
    foundDateAvailabilityFromUser.times = foundDateAvailabilityFromUser.times.filter((e)=> e.startTime !== null && e.endTime !== null)
  }
  let times = (calenderAvilablity.availabilityHours === METTING_AVAILABILITY.specific_days || calenderAvilablity.availabilitySettings === METTING_AVAILABILITY.specific_days) ? dayInfo.times : []
  console.log('foundDateAvailabilityFromUser', foundDateAvailabilityFromUser, times, !foundDateAvailabilityFromUser?.times?.length)
  console.log('calenderAvilablity', calenderAvilablity)

  if ((!times?.[0]?.startTime || !times?.[0]?.endTime) && !foundDateAvailabilityFromUser?.times?.length) {
    console.log('')
    timeSlots = generateTimeSlotsWithAMPM(calenderAvilablity.hourlySlotTime || brandDetails?.features?.meeting_time_slot_difference_in_mins);
  } else {
    const slots = createTimeSlots(foundDateAvailabilityFromUser?.times?.length ? foundDateAvailabilityFromUser?.times : times, localtime, calenderAvilablity.hourlySlotTime);
    console.log('slotess------', slots)
    timeSlots = slots.map((e) => {
      return { value: e, label: moment(e, 'HH:mm').format('hh:mm A') }
    })
  }

  // if (foundDateAvailabilityFromUser?.times?.length) {
  //   foundDateAvailabilityFromUser.times.forEach((d) => {
  //     const tF = d.startTime;
  //     const tT = d.endTime;
  //     const startIndex = timeSlots.findIndex((e) => e.value === tF);
  //     const endIndex = timeSlots.findIndex((e) => e.value === tT);
  //     if (startIndex >= 0 && endIndex >= 0) {
  //       const sliceI = (endIndex - startIndex) + 1
  //       timeSlots.splice(startIndex, sliceI)
  //     }
  //   })
  // }

  // const dateAvailability = await this.meetingService.getUsersAvailabilityByDate(uid, selectedDateFormatted).toPromise()
  console.log('dateAvailability',dateAvailability, selectedDateFormatted)
  console.log('timeee ', timeSlots)
  const dateAvailabilityList = Array.isArray(dateAvailability) ? dateAvailability : [];
  dateAvailabilityList.forEach((d) => {
    let tF, tT;
    if(localtime) {
      tF = ((d.timeFrom||d.startTime).split(':').slice(0, 2).join(":"))
      tT = ((d.timeTo||d.endTime).split(':').slice(0, 2).join(":"))
    }else{
      tF = convertToLocalTime((d.timeFrom||d.startTime).split(':').slice(0, 2).join(":"))
      tT = convertToLocalTime((d.timeTo||d.endTime).split(':').slice(0, 2).join(":"))
    }

    const startIndex = timeSlots.findIndex((e) => e.value === tF);
    const endIndex = timeSlots.findIndex((e) => e.value === tT);

    if (startIndex >= 0 && endIndex >= 0) {
      // const sliceI = (endIndex - startIndex) + 1
      const sliceI = (endIndex - startIndex)
      if(calculatingEndTime){
        timeSlots.splice(startIndex+1, sliceI)
      }else{
        console.log('start indexxx', startIndex,sliceI,timeSlots)
        timeSlots.splice(startIndex, sliceI)
      }
      // timeSlots.splice(startIndex, sliceI)
      // timeSlots.splice(startIndex+1, sliceI)
    }


    // Edge case handling: starttime of any slots shouldn't be present in start time
    if(!calculatingEndTime) {
      const newStartIndex = timeSlots.findIndex((e) => e.value === tF);
      if(newStartIndex>=0) {
        timeSlots.splice(newStartIndex,1)
      }
    }


    console.log({ tF, tT, startIndex, endIndex })
  })
  console.log('timeee 2', timeSlots)
  timeSlots = filterPastTimes(timeSlots, selectedDateFormatted);
  console.log('timeee 3', timeSlots)
  timeSlots = filterBufferTime(timeSlots, selectedDateFormatted, bufferTime);
  console.log('timeee 4', timeSlots)
  return timeSlots;
}


function filterBufferTime(timesArray, dateParam, bufferTime = 0) {
   // Get the current time and calculate the minimum allowed time based on bufferTime
   const now = moment();
    const givenDate = moment(dateParam); // Convert the date parameter to a moment object
   const bufferDuration = moment.duration(bufferTime, 'hours');
   const minAllowedTime = now.add(bufferDuration).format('HH:mm');

   // Filter out time slots that are within the buffer period
  if (givenDate.isSame(now, 'day')) {
    timesArray = timesArray.filter(slot => slot.value > minAllowedTime);
  }
  return timesArray
}

function filterPastTimes(timesArray, dateParam) {
  const now = moment(); // Current time in local timezone
  const givenDate = moment(dateParam); // Convert the date parameter to a moment object

  // Check if the given date is today
  if (givenDate.isSame(now, 'day')) {
      return timesArray.filter(time => {
          const timeMoment = moment(time.value, "HH:mm");
          return timeMoment.isAfter(now); // Keep only times after the current time
      });
  }

  // If the given date is not today, return the original array
  return timesArray;
}

export const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const getAccountTypeTitle = (accType:ACCOUNT_TYPE):string=> {
  const brandDetails:IBrandDetails = window.brandDetails || JSON.parse(localStorage.getItem('brandDetails') || '{}')
  return formatEnumStringForUI(brandDetails?.features?.[AccountTypeTitleKey[accType]]|| accountTypelabelMap[accType] || accType)
}

export const getUserTypeArray= (profileData: IProfileDetails) => {
  if (!window.brandDetails) {
    return []
  }

  const preparedData = {}
  profileData.connectionMatrix.forEach((matrix) => {
    preparedData[matrix.otherProfileType || matrix.profileType2] = {
      canSearch: matrix.canSearch,
      canConnect: matrix.canConnect
    }
  })

  const brandDetails:IBrandDetails = window.brandDetails
  const userTypesArr = [
    brandDetails.users?.startups && preparedData[ACCOUNT_TYPE.STARTUP]?.canSearch ? {
      type: ACCOUNT_TYPE.STARTUP,
      label: getAccountTypeTitle(ACCOUNT_TYPE.STARTUP)
    } : null,
    brandDetails.users?.investors&& preparedData[ACCOUNT_TYPE.INVESTOR]?.canSearch ? {
      type: ACCOUNT_TYPE.INVESTOR,
      label: getAccountTypeTitle(ACCOUNT_TYPE.INVESTOR)
    } : null,
    brandDetails.users?.mentors && preparedData[ACCOUNT_TYPE.MENTOR]?.canSearch? {
      type: ACCOUNT_TYPE.MENTOR,
      label: getAccountTypeTitle(ACCOUNT_TYPE.MENTOR)
    } : null,
    brandDetails.users?.corporates && preparedData[ACCOUNT_TYPE.CORPORATE]?.canSearch? {
      type: ACCOUNT_TYPE.CORPORATE,
      label: getAccountTypeTitle(ACCOUNT_TYPE.CORPORATE)
    } : null,
    brandDetails.users?.service_providers && preparedData[ACCOUNT_TYPE.SERVICE_PROVIDER]?.canSearch? {
      type: ACCOUNT_TYPE.SERVICE_PROVIDER,
      label: getAccountTypeTitle(ACCOUNT_TYPE.SERVICE_PROVIDER)
    } : null,
    brandDetails.users?.partners && preparedData[ACCOUNT_TYPE.PARTNER]?.canSearch? {
      type: ACCOUNT_TYPE.PARTNER,
      label: getAccountTypeTitle(ACCOUNT_TYPE.PARTNER)
    } : null,
    brandDetails.users?.program_offices&& preparedData[ACCOUNT_TYPE.PROGRAM_OFFICE]?.canSearch ? {
      type: ACCOUNT_TYPE.PROGRAM_OFFICE,
      label: getAccountTypeTitle(ACCOUNT_TYPE.PROGRAM_OFFICE)
    } : null,
    brandDetails.users?.individuals && preparedData[ACCOUNT_TYPE.INDIVIDUAL]?.canSearch? {
      type: ACCOUNT_TYPE.INDIVIDUAL,
      label: getAccountTypeTitle(ACCOUNT_TYPE.INDIVIDUAL)
    } : null,
  ].filter((e)=>!!e)
  return userTypesArr
}


export const sortEventsAndPrograms = (programs: Array<any>, sortKey:string) => {
  // const now = moment(); // Get the current date and time
  const now = moment().subtract(1,'day')

  const futurePrograms = [];
  const pastPrograms = [];

  programs.forEach((booking) => {
    const programStartDate = moment(`${booking[sortKey]}`, 'YYYY-MM-DD HH:mm:ss');

    if (programStartDate.isSameOrAfter(now)) {
      futurePrograms.push(booking);
    } else {
      pastPrograms.push(booking);
    }
  });


  futurePrograms.sort((a, b) => {
    const dateA = moment(`${a[sortKey]}`, 'YYYY-MM-DD HH:mm:ss');
    const dateB = moment(`${b[sortKey]}`, 'YYYY-MM-DD HH:mm:ss');
    return dateA.diff(dateB); // Ascending order (nearest date first)
  });

  pastPrograms.sort((a, b) => {
    const dateA = moment(`${a[sortKey]}`, 'YYYY-MM-DD HH:mm:ss');
    const dateB = moment(`${b[sortKey]}`, 'YYYY-MM-DD HH:mm:ss');
    return dateB.diff(dateA); // Descending order (most recent past date first)
  });

  return [...futurePrograms, ...pastPrograms];
}

/**
 * SAN-755 — displayOrder-first sort for the combined Startup Programs +
 * Custom Programs listing. Programs with an explicit `displayOrder` are
 * placed first (ascending); everything else keeps the existing date-based
 * sort. Array.prototype.sort is stable in all supported browsers/Node, so
 * running this over the already date-sorted array preserves that relative
 * order for null-displayOrder items and for ties between equal displayOrder
 * values, rather than needing a separate tiebreak key.
 */
export const sortProgramsByDisplayOrder = (programs: Array<any>, dateSortKey: string) => {
  const dateSorted = sortEventsAndPrograms(programs, dateSortKey);

  return [...dateSorted].sort((a, b) => {
    const aHasOrder = a.displayOrder !== null && a.displayOrder !== undefined;
    const bHasOrder = b.displayOrder !== null && b.displayOrder !== undefined;

    if (aHasOrder && bHasOrder) {
      return a.displayOrder - b.displayOrder;
    }
    if (aHasOrder) return -1;
    if (bHasOrder) return 1;
    return 0;
  });
}


export const getMissingFieldsMap = (profileCompleteness, customFormUrlPrefix) => {
  let missingFields = [];

  Object.keys(profileCompleteness.forms).forEach((e: string) => {
    let url = MissingFormKeyToUrlMapping[e]
    let fields = profileCompleteness.forms[e].missingFields || []
    fields = fields.map(f => {
      let id, parts;
      let formattedString = f
      const isCustomForm = f.includes('--*--')

      let routeObj = getTitleFromNavLink(url)
      let groupTitle = routeObj?.title || ''


      if (isCustomForm) {
        parts = f.split("--*--");
        id = parts[1].split('(')[0];
        const title = `${parts[1].split('(')[1]}`
        formattedString = `${parts[0]}`;
        url = `/${customFormUrlPrefix}/edit/custom-forms/${id}/${createSlug(title)}`
        groupTitle = title.replace(')', '')
      }

      // if(isCustomForm)  {
      //   groupTitle =
      // }
      // SAN-1473 (EX-06) — why this item is worth filling (shown only with the
      // notification centre on, by the completeness widgets and dashboard-v2).
      const benefit = profileGapBenefit(formattedString, isCustomForm ? 'custom_forms' : e)
      return {
        url: url,
        field: formattedString,
        benefit: benefit?.text || null,
        benefitRank: benefit?.rank || 0,
        id,
        routeObj,
        groupTitle,
        // SAN-1003 — custom forms group by form uuid, not title, so two
        // custom forms sharing a title don't share one missing-fields group.
        groupId: isCustomForm ? id : groupTitle
      }
    })
    missingFields = [...missingFields, ...fields]
  })

  const groupedArray = missingFields.reduce((acc, item) => {
    // Find if group already exists
    const existingGroup = acc.find(group => group.groupId === item.groupId);

    if (existingGroup) {
      existingGroup.value.push(item);
    } else {
      acc.push({ key: item.groupTitle, groupId: item.groupId, value: [item] });
    }

    return acc;
  }, []);

  console.log('groupedData', groupedArray);
  return groupedArray
  // this.missingFields = groupedData
  // console.log("this.missingFields", this.missingFields)
}


/**
 * SAN-498 — Given the ordered nav-links array for a profile-edit page and a
 * per-link completeness predicate (e.g. a nav-links component's own
 * `isCustomProfileFormValid(link)`), returns the index of the first
 * incomplete tab. If every tab is complete, returns `navLinks.length` (i.e.
 * "beyond the end") so that no target index can ever be considered past it.
 */
export const getFirstIncompleteNavLinkIndex = (
  navLinks: any[],
  isLinkComplete: (link: any) => boolean
): number => {
  if (!navLinks || !navLinks.length) {
    return 0;
  }
  const idx = navLinks.findIndex((link) => !isLinkComplete(link));
  return idx === -1 ? navLinks.length : idx;
};

/**
 * SAN-498 — Decides whether a nav-link click should be blocked: a click is
 * blocked only when it targets a tab strictly ahead of the currently active
 * tab AND strictly ahead of the first incomplete tab in `navLinks` order
 * (Design decision 2 — Option B). Backward navigation (target index <=
 * current index) is never blocked, matching today's behavior exactly.
 */
export const isForwardTabNavigationBlocked = (
  navLinks: any[],
  activeItem: any,
  targetLink: any,
  isLinkComplete: (link: any) => boolean
): boolean => {
  if (!navLinks || !navLinks.length) {
    return false;
  }
  const currentIndex = navLinks.indexOf(activeItem);
  const targetIndex = navLinks.indexOf(targetLink);
  if (targetIndex === -1) {
    return false;
  }
  const firstIncompleteIndex = getFirstIncompleteNavLinkIndex(navLinks, isLinkComplete);
  return targetIndex > currentIndex && targetIndex > firstIncompleteIndex;
};

/**
 * SAN-499 — Given a route URL (e.g. `/startups/edit/financial-details` or
 * `/investors/edit/custom-forms/:uuid/:slug`), returns the profile-completion
 * "edit area" prefix it belongs to (e.g. `/startups/edit`), or `null` if the
 * URL isn't inside a recognized `<type>/edit/...` area at all (including the
 * separate, out-of-scope `edit-preview/...` route family, finding 4 — the
 * literal segment must be exactly `edit`, not merely start with it).
 */
export function getProfileEditAreaPrefix(url: string | null | undefined): string | null {
  if (!url) {
    return null;
  }
  const match = url.match(/^(\/[^/?#]+\/edit)(?=\/|\?|#|$)/);
  return match ? match[1] : null;
}

/**
 * SAN-499 — Decides whether navigating from `currentUrl` to `nextUrl` leaves
 * the current type's own profile-completion edit area entirely (finding 1).
 * Returns `false` (never prompt) when `currentUrl` isn't itself inside a
 * recognized edit area, when `nextUrl` is missing, or when `nextUrl` still
 * starts with the same `<type>/edit` prefix (in-area step/tab navigation,
 * including tenant-admin custom-form tabs) — the guard should only prompt
 * when this returns `true`.
 */
export function isLeavingProfileEditArea(currentUrl: string | null | undefined, nextUrl: string | null | undefined): boolean {
  const prefix = getProfileEditAreaPrefix(currentUrl);
  if (!prefix) {
    return false;
  }
  if (!nextUrl) {
    return false;
  }
  return !(nextUrl === prefix || nextUrl.startsWith(prefix + '/') || nextUrl.startsWith(prefix + '?') || nextUrl.startsWith(prefix + '#'));
}

export function orderBy<T>(array: T[], key: keyof T, order: 'asc' | 'desc' = 'asc'): T[] {
  return [...array].sort((a, b) => {
    const valueA = a[key];
    const valueB = b[key];

    if (typeof valueA === 'string' && typeof valueB === 'string') {
      const comparison = valueA.localeCompare(valueB);
      return order === 'asc' ? comparison : -comparison;
    }

    if (typeof valueA === 'number' && typeof valueB === 'number') {
      const comparison = valueA - valueB;
      return order === 'asc' ? comparison : -comparison;
    }

    throw new Error(`Unsupported value types for sorting: ${typeof valueA} and ${typeof valueB}`);
  });
}


export const filterAvailableSlots = (slots, endTime: string, duration: number) => {
  const endMoment = moment(endTime, "HH:mm");

  return slots.filter(slot => {
      const slotMoment = moment(slot.value, "HH:mm");
      return slotMoment.clone().add(duration, 'minutes').isSameOrBefore(endMoment);
  });
}

/**
 * SAN-246/247/248 — per-tenant custom onboarding branding.
 *
 * Decision #4 ("partial configuration"): a tenant can be in Custom mode
 * overall while leaving any *individual* screen unconfigured — that screen
 * must still fall back to today's default rendering exactly. This is the
 * single check every hero/form panel gates on: is there actually anything
 * here worth rendering, not just "is the flag on".
 */
export function hasCustomOnboardingHeroContent(hero: IOnboardingDesignHero | null | undefined): boolean {
  if (!hero) {
    return false;
  }
  return !!(
    hero.headingPrimaryText ||
    hero.headingAccentText ||
    (hero.bodyVisible && hero.bodyItems?.length) ||
    hero.bgColor ||
    hero.bgImage
  );
}

/**
 * SAN-386 -- adds the current spoke's own logo into the onboarding logo
 * lockup as one more partner mark (logo2-4), alongside whatever the Hub
 * already configured there. Never touches logo1 (the Hub's own main mark,
 * rendered larger by `onboarding-logo-lockup.component`) and never drops an
 * existing slot -- only fills the first empty one. No-op (returns `logos`
 * unchanged) when there's no spoke logo to add, or every slot is already
 * taken.
 */
export function mergeSpokeLogoIntoOnboardingLogos(
  logos: IOnboardingDesignLogos | null,
  spokeLogoUrl: string | null | undefined,
): IOnboardingDesignLogos | null {
  if (!spokeLogoUrl) {
    return logos;
  }
  const base: IOnboardingDesignLogos = logos || { logo1: null, logo2: null, logo3: null, logo4: null };
  if (base.logo2 === spokeLogoUrl || base.logo3 === spokeLogoUrl || base.logo4 === spokeLogoUrl) {
    return base;
  }
  if (!base.logo2) {
    return { ...base, logo2: spokeLogoUrl };
  }
  if (!base.logo3) {
    return { ...base, logo3: spokeLogoUrl };
  }
  if (!base.logo4) {
    return { ...base, logo4: spokeLogoUrl };
  }
  return base;
}

/**
 * Decision #9 (finalized): precedence, not blending. If a hero background
 * image is set it renders and the color never shows; the color only ever
 * renders when no image is set. Returns null when neither is set so callers
 * can cleanly no-op.
 */
export function resolveHeroBackground(hero: IOnboardingDesignHero | null | undefined): { image: string | null, color: string | null } {
  if (!hero) {
    return { image: null, color: null };
  }
  if (hero.bgImage) {
    return { image: hero.bgImage, color: null };
  }
  return { image: null, color: hero.bgColor || null };
}

/**
 * SAN-246/247/248: a tenant's custom onboarding card background
 * (form.bgColor) can be configured to anything — light or dark. Neutral UI
 * text that sits directly on that card (a "Back to Home" link, muted
 * subheadings, input labels) can't use a single hardcoded color like
 * `text-dark` the way the rest of this app does, or it goes invisible on a
 * dark card exactly like a light-card assumption would break on a dark one.
 * Returns white or near-black based on the background's perceived
 * luminance (standard WCAG-style relative luminance, simplified) so this
 * text stays readable regardless of what a tenant picks. Falls back to the
 * dark-text default (matching this app's normal light-card assumption)
 * when no background color is set at all.
 */
/**
 * Converts a hex color to an rgba() string at the given alpha — used to tint
 * a hero background image with a translucent overlay of the tenant's own
 * configured color (matching the reference design's darkened-image look)
 * instead of a hardcoded color that would look wrong for a differently
 * branded tenant. Falls back to a neutral dark tint when no color is set at
 * all (bgColor is unset/empty when only bgImage is configured, per
 * Decision #9 — color and image are mutually exclusive as a literal
 * background, but the color is still meaningful here as an overlay tint).
 */
export function hexToRgba(hex: string | null | undefined, alpha: number, fallback: string): string {
  if (!hex) {
    return fallback;
  }
  const clean = hex.replace('#', '');
  if (clean.length !== 3 && clean.length !== 6) {
    return fallback;
  }
  const full = clean.length === 3 ? clean.split('').map((c) => c + c).join('') : clean;
  const r = parseInt(full.substring(0, 2), 16);
  const g = parseInt(full.substring(2, 4), 16);
  const b = parseInt(full.substring(4, 6), 16);
  if ([r, g, b].some((n) => Number.isNaN(n))) {
    return fallback;
  }
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function getReadableTextColor(bgColor: string | null | undefined, fallback: string = '#111827'): string {
  if (!bgColor) {
    return fallback;
  }
  const hex = bgColor.replace('#', '');
  if (hex.length !== 3 && hex.length !== 6) {
    return fallback;
  }
  const full = hex.length === 3 ? hex.split('').map((c) => c + c).join('') : hex;
  const r = parseInt(full.substring(0, 2), 16);
  const g = parseInt(full.substring(2, 4), 16);
  const b = parseInt(full.substring(4, 6), 16);
  if ([r, g, b].some((n) => Number.isNaN(n))) {
    return fallback;
  }
  // Relative luminance (ITU-R BT.601 approximation) — cheap and good enough
  // for a binary light/dark decision, not a precision colorimetry need.
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? '#111827' : '#ffffff';
}


/* SAN-1003 — the missing-fields group (from getMissingFieldsMap) for a
   profile edit nav link. Custom-form tabs match by the form uuid (the
   link's own `uuid`, else the one in its route), so custom forms sharing a
   title never share a red tick; standard tabs match by title (or
   `titleOverride` when the tab's title differs from its completeness
   group's). */
export const findMissingFieldsGroupForLink = (missingFields, link, titleOverride?: string) => {
  const customFormUUID = (link?.custom && link?.uuid) || link?.route?.match(/\/custom-forms\/([^/?#]+)/)?.[1];
  const groupId = customFormUUID || titleOverride || link?.title;
  return (missingFields || []).find(group => (group.groupId ?? group.key) === groupId);
}

/**
 * SAN-1473 (EX-06) — the most useful missing items first: fields that feed
 * investor search and matching, then section-level gaps. For the dashboard's
 * "Why complete your profile" list.
 */
export const topProfileGaps = (profileCompleteness, customFormUrlPrefix: string, limit = 3) => {
  if (!profileCompleteness?.forms) return [];
  return getMissingFieldsMap(profileCompleteness, customFormUrlPrefix)
    .reduce((all, group) => [...all, ...group.value], [])
    .filter((item) => !!item.benefit)
    .sort((a, b) => b.benefitRank - a.benefitRank)
    .slice(0, limit)
    .map((item) => ({ field: item.field, benefit: item.benefit, url: item.url }));
}
